import { render, staticRenderFns } from "./PaymentMethodConfig.vue?vue&type=template&id=5c4a4d02"
import script from "./PaymentMethodConfig.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodConfig.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports